/// <reference path="../typings/tsd.d.ts" />


/*
 * urnerboden.ts
 *
 * Written by:  Peter Janser, https://wwww.binaryone.ch/
 *
 */

//constants from CSS
var tabletHeight		= 600,
	desktopHeight		= 768,
	desktopLargeHeight	= 900;

//use vars from template file
declare var l0Factor: number;
declare var l1Factor: number;
declare var l2Factor: number;
declare var l3Factor: number;
declare var l4Factor: number;
declare var home: boolean;
declare var urnerboden_main: {
	ajaxurl: string
};
declare var page_by_id: any;

declare var isSafari: boolean;



var DEBUG: boolean = false;

//helper
var sign = function (x: number){
	return (x == 0 ? 0 : Math.abs(x) / x);
};
function setCookie(cname, cvalue, exdays){
    var d = new Date();
	exdays = exdays || 365;
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}
function getCookie(cname){
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

//main function
jQuery(function (){
	var uboden = new Urnerboden(),
		main = Urnerboden.main;
});


class Urnerboden {
	//private static vars
	//FROM CSS
	private static SCREENPADDING: number = 31;

	//OTHER
	private static DEGREES: number = 400;
	private static TOPLAYERHEIGHT: number = 1000;
	private static TOPLAYERWIDTH: number = 4380;
	private static layerProportion: number = Urnerboden.TOPLAYERWIDTH / Urnerboden.TOPLAYERHEIGHT;

	private static SCROLLTIMEOUT: number = 768; //ms
	private static SCROLLANIMTRIGGER: number = 50;
	private static SCROLLDIST: number = 0; //Pixelspeed/s * SCROLLTIMEOUT = Pixel per scroll event
	private static SHOWHIDETIME: number = 300;
	private static ww: number = 0; //window width, changing during resize event
	private static wh: number = 0; //window height, changing during resize event
	public static bgWidth: number = 0;
	private static halfBgWidth: number = 1;
	private static bgFactor: number = 1;

	//helper
	public static ScrollLeft: number = 0;
	public static isScrolling: boolean = false;
	private static hasLoaded: boolean = false;
	private static isMenuOpening: boolean;
	public static mouseOverMain: boolean;
	private static prevScrollDelta: number = 0;
	public static hasFullscreen: boolean = false;
	private static newVisit: boolean = true;
	private static imgCount: number = 0;
	private static loadedImgCount: number = 0;

	//KEY DEFINITIONS
	private static KEY_HOME: number = 36;
	private static KEY_END: number = 35;
	private static KEY_PGUP: number = 33;
	private static KEY_PGDN: number = 34;
	private static KEY_ESC: number = 27;

	//DOM placeholders for improved performance
	private static entries: JQuery = null;
	private static body: JQuery;
	public static main: JQuery;
	public static movingContainer: JQuery;
	public static fullbox: JQuery;
	public static fullboxContainer: JQuery;
	private static l0: JQuery;
	private static l1: JQuery;
	private static l2: JQuery;
	private static l3: JQuery;
	private static l4: JQuery;
	private static prevPage: JQuery;
	private static nextPage: JQuery;
	private static menu: JQuery;
	private static logo: JQuery;
	private static logoLeft: JQuery;
	private static loader: JQuery;
	private static cartDot: JQuery;


	constructor(){
		Urnerboden.mouseOverMain = false;
		Urnerboden.body = jQuery("body");
		Urnerboden.main = Urnerboden.body.children("#main");
		Urnerboden.movingContainer = Urnerboden.main.children(".layers");
		Urnerboden.fullbox = Urnerboden.body.children("#fullbox");
		Urnerboden.fullboxContainer = Urnerboden.fullbox.find(".fullscreen-content-inner");
		Urnerboden.entries = Urnerboden.main.find(".links-entry");
		Urnerboden.ww = jQuery(window).width();
		Urnerboden.wh = jQuery(window).height();
		Urnerboden.menu = Urnerboden.body.children(".left");
		Urnerboden.logo = Urnerboden.menu.children(".logo");
		Urnerboden.logoLeft = Urnerboden.body.children("#logo-left");
		Urnerboden.prevPage = Urnerboden.movingContainer.children(".prev-page");
		Urnerboden.nextPage = Urnerboden.movingContainer.children(".next-page");
		Urnerboden.loader = jQuery("#loading");
		Urnerboden.l0 = Urnerboden.main.find(".layer0");
		Urnerboden.l1 = Urnerboden.main.find(".layer1");
		Urnerboden.l2 = Urnerboden.main.find(".layer2");
		Urnerboden.l3 = Urnerboden.main.find(".layer3");
		Urnerboden.l4 = Urnerboden.main.find(".layer4");
		Urnerboden.SCROLLDIST = Urnerboden.ww * Urnerboden.SCROLLTIMEOUT / 3072;

		Urnerboden.main.mouseover(function ()
		{
			Urnerboden.mouseOverMain = true;
		});
		Urnerboden.menu.mouseover(function ()
		{
			Urnerboden.mouseOverMain = false;
		});

		//find and set href link to next mainpage
		let activeItem: JQuery =  Urnerboden.menu.find(".current-menu-item"),
			prev = activeItem.prev(),
			next = activeItem.next();
		if(prev.length > 0){
			Urnerboden.prevPage.on("click touchstart", function(){
				goTo(prev.children("a").attr("href"));
			});
			Urnerboden.prevPage.addClass("visible");
		}
		if(next.length > 0){
			Urnerboden.nextPage.on("click touchstart", function(){
				goTo(next.children("a").attr("href"));
			});
			Urnerboden.nextPage.addClass("visible");
		}

		//hide menu and containers
		Urnerboden.movingContainer.on("click touchstart", function (e)
		{
			if (Urnerboden.menu.hasClass("menu-open"))
				closeMenu();
			//else
			//Urnerboden.closeAllCurrentlyOpenContainers();
		});

		if (typeof(l0Factor) !== "undefined") {
			jQuery(window).on("resize", Urnerboden.fitLayers);

			jQuery(window).load(Urnerboden.loaded);
		}
	}
	private static loaded(){
		Urnerboden.hasLoaded = true;
		home = (typeof home === "undefined" ? false : home);

		Urnerboden.fitLayers();

		//hide loader if in landscape mode
		if (Urnerboden.wh < Urnerboden.ww){
			Urnerboden.loader.fadeOut(800);
			Urnerboden.movingContainer.boDraggable(true).boScrollable(true);
			Urnerboden.doFirstVisit();
		} else
			Urnerboden.loader.addClass("rotate-message");
	}
	private static doFirstVisit(){
		//start scrolling
		Urnerboden.movingContainer.boMove(true);
		if (Urnerboden.newVisit) {
			//check if cookie exists
			if (home && true || !document.cookie || document.cookie && getCookie("visited") == "") {
				console.log("cookie not found... adding new");
				setCookie("visited", "true", 365);
				Urnerboden.newVisit = false;

				//do stuff
			}
		}
	}
	private static fitLayers(){
		Urnerboden.closeAllCurrentlyOpenContainers();
		let layers = Urnerboden.main.find(".layers");

		//set static variables which are changed during resize
		Urnerboden.ww = jQuery(window).width();
		Urnerboden.wh = jQuery(window).height();
		var titleBarHeight = Urnerboden.wh - window.innerHeight;
		if(titleBarHeight > 0)
			Urnerboden.wh -= titleBarHeight;

		// alert("wh="+Urnerboden.wh
		// 	+" layers height="+Urnerboden.movingContainer.height()
		// 	+" a="+window.outerHeight
		// 	+" a1="+window.innerHeight
		// 	+" b="+window.screen.height);

		//set layers width for correct scrolling 
		layers.width(Urnerboden.wh * Urnerboden.layerProportion);
		// alert(Urnerboden.wh);
		//fix for mobile screens with title bar
		document.documentElement.style.height = Urnerboden.wh+"px";
		document.body.style.position = "relative";
		Urnerboden.bgWidth = layers.width();
		Urnerboden.halfBgWidth = Urnerboden.bgWidth / 2;
		Urnerboden.bgFactor = Urnerboden.bgWidth / Urnerboden.main.width();

		//position all links on the ruler
		Urnerboden.entries.each(function (index, element)
		{
			let entry = jQuery(element),
				lineContainer = entry.children(".line-container"),
				hoverbox = entry.children(".title-hoverbox"),
				type = entry.data('contenttype'),
				xPos = entry.data('xpos') / Urnerboden.DEGREES,
				yPos = entry.data('ypos');

			if (type == "textbox") {
				let contentBox = hoverbox.find(".content"),
					icon = hoverbox.find(".w3-icon"),
					linkNameBox = hoverbox.find(".link-name"),
					linkTitle = hoverbox.find(".link-title"),
					titleHeight = linkTitle.innerHeight()
						+ hoverbox.find(".link-subtitle").innerHeight()
						+ (Urnerboden.wh > tabletHeight ? 40 : 24); //padding-top + padding-bottom of hoverbox

				icon.css({ top: titleHeight / 2 });
				lineContainer.css({
					height: yPos * Urnerboden.wh / 100
				});
				//set width
				if (Urnerboden.wh < tabletHeight)
					contentBox.data("width", 180);
				else
					contentBox.data("width", 300);

				if (entry.hasClass("show")) {
					contentBox.width(contentBox.data("width"));
					contentBox.height(contentBox.children().first().innerHeight());
				} else
					contentBox.width(Urnerboden.maxWidthTitle(linkTitle));
			}
			if (type == "fullbox" || type == "multipage") {
				if (index == 0 && xPos * Urnerboden.bgWidth - hoverbox.innerWidth() < Urnerboden.menu.innerWidth())
					xPos = (hoverbox.innerWidth() + Urnerboden.menu.innerWidth() - 40) / Urnerboden.bgWidth;
			}
		});

		//if in portrait mode
		if (Urnerboden.wh >= Urnerboden.ww) {
			Urnerboden.loader.addClass("rotate-message");
			Urnerboden.loader.show();
			return;
		} else if (Urnerboden.loader.is(":visible") && Urnerboden.hasLoaded) {
			Urnerboden.loader.fadeOut(800);
			Urnerboden.movingContainer.boDraggable(true).boScrollable(true);
			Urnerboden.doFirstVisit();
		}
	}
	public static alignCloseBtn(container: JQuery){
		let closeBtn = container.find(".w3-icon.close");
		if(closeBtn.parent().css("position") !== "fixed") return;

		let scrollBarWidth = container.outerWidth() - container[0].clientWidth;
		if(scrollBarWidth > 0){
			container.find(".slick-slider").css("margin-left", scrollBarWidth/2);
			//container.find(".w3-icon.close").css({right: scrollBarWidth+"px"});
		} /*else {
			container.find(".w3-icon.close").css({right: 0+"px"});
		}*/
	}

	/*
		* Opens the content box when being clicked
		* and scrolls into position
		*
		* Parameters:
		*
		* sender = sender object (links-entry DIV)
		*
		*/
	private static toggleContentBox(e: Event){
		let obj: JQuery = jQuery(e.target),
			hoverBox: JQuery = obj.closest(".title-hoverbox"), //.title-hoverbox
			linksEntry: JQuery = hoverBox.closest(".links-entry");

		if (obj.is("a") || obj.is("audio") || obj.hasClass("audio-inline")) {
			console.log("Closing prevented!");
			return;
		}

		if (linksEntry.hasClass("show")) {
			Urnerboden.closeContentBox(linksEntry);
		} else {
			//fade logo
			Urnerboden.fadeLeftLogo(true);
			if (jQuery(".links-entry.show").length > 0) {
				//close all other open contentboxes
				Urnerboden.closeAllCurrentlyOpenContainers();
				//wait until closing animation has ended
				setTimeout(function ()
				{
					//open contentBox
					Urnerboden.showContentBox(linksEntry);
				}, 1200);
			} else {
				Urnerboden.showContentBox(linksEntry);
			}
		}
	}
	private static closeContentBox(container: JQuery){
		if (!container || container.length <= 0) return;

		let linkNameBox = container.find(".link-name"),
			linkTitle = linkNameBox.children(".link-title"),
			content = linkNameBox.children(".content"),
			hoverbox = container.find(".title-hoverbox"),
			lineContainer = container.children(".line-container");

		//now hide container
		container.removeClass("show");
		Urnerboden.body.removeClass("fullbox-opened textbox-opened");
		if (Urnerboden.wh >= tabletHeight) {
			//wait until hiding has ended, then move down to original position
			setTimeout(function ()
			{
				content.animate({ width: Urnerboden.maxWidthTitle(linkTitle), height: 0 }, 300, function ()
				{
					container.find(".w3-icon.plussm").removeClass("tilted");
					setTimeout(function ()
					{
						lineContainer.animate({ height: container.data("ypos") + "%" }, 300, function ()
						{
							hoverbox.removeClass("opening");
						});
					}, 300);
				});
			}, 300);
		}
	}
	private static showContentBox(container: JQuery){
		Urnerboden.scrollEntryInView(container, function ()
		{
			Urnerboden.showContentBoxHelper(container);
		});
	}
	private static showContentBoxHelper(container: JQuery){
		//now show container
		let linkNameBox = container.find(".link-name"),
			linkTitle = linkNameBox.children(".link-title"),
			content = linkNameBox.children(".content"),
			hoverbox = container.find(".title-hoverbox"),
			p = container.parent()[0],
			x = getCurrentX(p),
			dim = hoverbox.children(".dim"),
			boxLeft = -x - container[0].offsetLeft;

		Urnerboden.body.addClass("fullbox-opened textbox-opened");
		if (Urnerboden.wh < tabletHeight) {
			//open modal (defined in CSS)
			dim[0].style.left = boxLeft + "px";
			content[0].style.left = boxLeft + Urnerboden.ww/2 + "px";
			hoverbox.addClass("opening");
			container.addClass("show");
		} else {
			let contentP = content.children().first(),
				lineContainer = container.children(".line-container");

			hoverbox.addClass("opening");
			//move 50% up
			lineContainer.animate({ height: /*(container.data("ypos") / 3) + */"12%" }, 300, function ()
			{
				container.find(".w3-icon.plussm").addClass("tilted");
				setTimeout(function ()
				{
					content.animate({ width: content.data("width"), height: content.children().innerHeight() }, 300, function ()
					{
						dim[0].style.left = boxLeft + "px";
						container.addClass("show");
					});
				}, 300);
			});
		}
	}

	private static showFullbox(sender: HTMLElement){
		let obj = jQuery(sender),
			linksEntry = obj.closest(".links-entry");

		//now show/hide sender container
		if (!Urnerboden.fullbox.hasClass("visible")) {
			if (Urnerboden.containerIsOnScreen(obj.parent()))
				Urnerboden.showFullboxHelper(linksEntry);
			else {
				Urnerboden.scrollEntryInView(linksEntry, function ()
				{
					Urnerboden.showFullboxHelper(linksEntry);
				});
			}
		}
	}
	private static showFullboxHelper(container: JQuery){
		//console.log("id="+container.data("id"));
		Urnerboden.loadFullboxContent(container.data("id"));
		Urnerboden.closeAllCurrentlyOpenContainers();
		Urnerboden.body.addClass("fullbox-opened");
		Urnerboden.hasFullscreen = true;
	}
	public static closeFullbox(){
		Urnerboden.fullbox.removeClass("visible").addClass("hidden");
		Urnerboden.body.removeClass("fullbox-opened");
		Urnerboden.hasFullscreen = false;
	}
	private static loadFullboxContent(id: number){
		//don't load anything, if content already there
		Urnerboden.fullbox.removeClass("hidden").addClass("visible");
		if(Urnerboden.fullbox.data("id") == id) return;
		//empty container and add loader GIF
		Urnerboden.fullboxContainer.html("");
		Urnerboden.fullbox.addClass("loading").data("id", id);
		Urnerboden.imgCount = 0;
		Urnerboden.loadedImgCount = 0;
		//load content from CMS
		jQuery.ajax({
			url: urnerboden_main.ajaxurl,
			type: "post",
			data:{
				action: "page_by_id",
				id: id
			},
			dataType: "html",
			success: Urnerboden.insertContentToFullbox,
			error: Urnerboden.onFullboxContentLoadFailed
		});
	}
	private static insertContentToFullbox(data: any){
		if(!data) return;
		Urnerboden.fullbox.removeClass("loading");
		Urnerboden.fullboxContainer.html(data);
		Urnerboden.alignCloseBtn(Urnerboden.fullbox);
		let imgs = Urnerboden.fullboxContainer.find("img");
		Urnerboden.imgCount = imgs.length;
		imgs.on("load", Urnerboden.onImgLoaded);
	}
	private static onImgLoaded(e){
		//check if all imgs are loaded
		if(++Urnerboden.loadedImgCount === Urnerboden.imgCount){
			Urnerboden.initSlider(Urnerboden.fullboxContainer);
			Urnerboden.alignCloseBtn(Urnerboden.fullbox);
		}
	}
	private static onFullboxContentLoadFailed(e){
		Urnerboden.fullboxContainer.html("<h2>Fehler: Der Inhalt konnte nicht geladen werden. Bitte das Fenster schliessen und nochmals versuchen.</h2>");
		Urnerboden.fullbox.removeAttr("data-id").removeClass("loading");
	}
	public static initSlider(container: JQuery){
		let	children = container.children("p").children().add(container.children("img")),
			sliders: JQuery[] = [],
			current: JQuery = null;
		// step through each child. If it's an <img /> and it has a directly following <img />
		// add them including all following <img /> to sliders as a group
		children.each(function(i, elem){
			let el = jQuery(elem);
			if(el.is("img")){
				if(!current)
					current = el;
				else
					current = current.add(el);
			} else {
				if(current && current.length > 1)
					sliders.push(current);
				current = null;
			}
		});
		if(current && current.length > 0)
			sliders.push(current);
		current = null;

		for(let i = 0; i < sliders.length; ++i){
			let imgs = sliders[i],
				slides = jQuery();
			//has more than 1 image => init slider
			if(imgs.length <= 1) break;
			//replace <img/> with <div /> and use img as background-image
			imgs.each(function(i, element){
				var el = jQuery(element),
					div = jQuery('<div class="centered-cover-img" style="background-image:url('+el.attr("src")+');">');
				el.replaceWith(div);
				slides = slides.add(div);
			});
			//wrap images with <div />
			slides.wrapAll("<div />");
			let slider = slides.parent("div");
			slider.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				speed: 300
			});
			let prev = slider.find(".slick-prev").addClass("w3-icon prev").detach(),
				next = slider.find(".slick-next").addClass("w3-icon next").detach();
			prev = prev.add(next);
			prev.wrapAll('<div class="slick-btns"/>');
			prev.parent().appendTo(slider);
		}
	}

	/**
		* Returns the max. width of the Title block. The maximum is the wider element of link-title or link-subtitle
		* @param titleContainer
		*/
	private static maxWidthTitle(linkTitle: JQuery): number{
		return Math.max(linkTitle.innerWidth(), linkTitle.siblings(".link-subtitle").innerWidth());
	}

	/**
		*
		* @param sender The close button of a fullbox
		*/
	private static closeAllCurrentlyOpenContainers(){
		jQuery(".links-entry.show").each(function (index, element)
		{
			let el = jQuery(element);
			Urnerboden.closeContainer(el);
		});
	}
	private static closeContainer(container: JQuery){
		if (!container || container.length <= 0) return;
		if (container.children(".container").hasClass("fullbox")) {
			Urnerboden.closeFullbox();
		} else {
			Urnerboden.closeContentBox(container);
		}
	}

	public static toggleSound(sender){
		let audioContainer = jQuery(sender),
			audioPlayer: JQuery = audioContainer.find("audio");

		if (audioContainer.hasClass("playing")){ //play
			audioPlayer.trigger("pause");
			audioPlayer.prop("currentTime", 0);
			audioContainer.removeClass("playing");
			audioPlayer.off();
		} else { //stop
			audioPlayer.trigger("play");
			audioContainer.addClass("playing");
			audioPlayer.on("ended", function(){
				audioContainer.removeClass("playing");
			});
		}
	}

	public static fadeOut(){
		Urnerboden.fadeLeftLogo(true);
		if (!Urnerboden.entries || Urnerboden.entries.length <= 0) return;
		//fadeOut entries behind the menu
		Urnerboden.entries.each(function (i: number, el: HTMLElement)
		{
			let jEl = jQuery(el), //el = .link-entry
				elLeft = getOffsetX(el), //left of line-container
				elWidth: number = el.offsetWidth,
				hoverbox: JQuery = jEl.children(".title-hoverbox"),
				elTop: number = hoverbox.position().top,
				fadeOutWidth = Urnerboden.logo.width() + Urnerboden.SCREENPADDING;//menuWidth = Urnerboden.menu.width();

			//do not fade out if mobile size
			if (Urnerboden.wh < tabletHeight) {
				jEl.removeClass("fadeout");
			} else {
				//change elLeft for fullbox
				if (jEl.hasClass("type-fullbox") || jEl.hasClass("type-multipage"))
					elLeft += 53 - hoverbox.innerWidth();

				//if (fadeOutWidth <= 0) fadeOutWidth = Urnerboden.logo.width() + Urnerboden.SCREENPADDING;
				if (!Urnerboden.logoLeft.hasClass("fade")
					&& elLeft <= Urnerboden.ScrollLeft + fadeOutWidth
					&& elTop < Urnerboden.logo.height() + Urnerboden.SCREENPADDING
					|| elLeft <= Urnerboden.ScrollLeft
				) { //fade out
					jEl.addClass("fadeout");
				} else {
					jEl.removeClass("fadeout");
				}
			}
		});
	}
	private static fadeLeftLogo(hide: boolean = false){
		if (Urnerboden.ScrollLeft > 60 || hide || Urnerboden.hasFullscreen) {
			Urnerboden.logoLeft.addClass("fade");
		} else {
			Urnerboden.logoLeft.removeClass("fade");
		}
	}

	public static jumpTo(id: number){
		closeMenu();
		let obj = Urnerboden.main.find("#entry-" + id);

		//click on the link
		obj.children(".title-hoverbox").click();
	}

	/**
		* Checks if the given container is within a specific position range on screen.
		* Only horizontal position is checked.
		* @param container Must be a .links-entry container!
		*/
	private static containerIsOnScreen(container: JQuery): boolean{
		let contLeft: number = container.offset().left,
			hoverbox: JQuery = container.children(".title-hoverbox");

		if (container.hasClass("type-fullbox") || container.hasClass("type-multipage"))
			contLeft += 53 - hoverbox.innerWidth();
		var x = getCurrentX(Urnerboden.main);
		return (x + Urnerboden.menu.width() <= contLeft
			&& contLeft + (Urnerboden.wh < tabletHeight ? 180 : 300) + 20 <= x + Urnerboden.ww);
	}

	/**
		* Scrolls the main container until the wanted entry shows up.
		* @param container A ".links-entry" JQuery container
		* @param callback A callback function which is called when the scrolling has finished.
		*/
	private static scrollEntryInView(container: JQuery, callback?: any){
		if (!container.hasClass("links-entry")) {
			console.log("Error: Wrong container in scrollEntryInView() function!");
			console.log(container);
			return;
		}
		if (Urnerboden.containerIsOnScreen(container)) {
			//invoke the callback
			if (callback) callback();
		} else {
			var dragContainer = container.parent()[0],
				newX = -container[0].offsetLeft + Urnerboden.ww/2;
				console.log("el offset="+container[0].offsetLeft+"new slide x="+newX+"dx="+(newX + getCurrentX(dragContainer)));
			slideToPosition(dragContainer, newX, newX + getCurrentX(dragContainer), callback);
		}
	}
}
